<template>
  <div 
    class="k-responsive" 
    :style="computedMeasurableStyles"
  >
    <div 
      v-if="computedAspectRatio" 
      class="k-responsive__sizer" 
      :style="{ paddingBottom: (1 / computedAspectRatio) * 100 + '%' }"
    ></div>
    
    <div class="k-responsive__content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KResponsive',
  props: {
    // Kuvasuhde (esim. 16/9 tai luku 1.7778)
    aspectRatio: [String, Number],
    // Maksimikorkeus (esim. '300px' tai 300)
    maxHeight: [String, Number],
    // Maksimileveys
    maxWidth: [String, Number],
    // Korkeus
    height: [String, Number],
    // Leveys
    width: [String, Number],
  },
  computed: {
    // Muutetaan luvut merkkijonoiksi yksikön (px) kanssa, jos ne ovat pelkkiä numeroita
    computedMeasurableStyles() {
      const styles = {};
      
      const convert = (val) => {
        if (!val) return undefined;
        return isNaN(val) ? val : `${val}px`;
      };

      if (this.height) styles.height = convert(this.height);
      if (this.width) styles.width = convert(this.width);
      if (this.maxHeight) styles.maxHeight = convert(this.maxHeight);
      if (this.maxWidth) styles.maxWidth = convert(this.maxWidth);

      return styles;
    },
    // Lasketaan kuvasuhde float-luvuksi, jos se on annettu merkkijonona (esim. "16/9")
    computedAspectRatio() {
      if (!this.aspectRatio) return undefined;
      
      if (typeof this.aspectRatio === 'number') {
        return this.aspectRatio;
      }
      
      if (typeof this.aspectRatio === 'string' && this.aspectRatio.includes('/')) {
        const [width, height] = this.aspectRatio.split('/').map(Number);
        if (width && height) return width / height;
      }
      
      return Number(this.aspectRatio) || undefined;
    }
  }
};
</script>

<style scoped>
.k-responsive {
  position: relative;
  overflow: hidden;
  display: flex;
  flex: 1 0 auto;
  max-width: 100%;
}

.k-responsive__sizer {
  transition: padding-bottom 0.2s complement;
  flex: 1 0 0px;
}

.k-responsive__content {
  flex: 1 0 0px;
  max-width: 100%;
  
  /* Kun kuvasuhde on käytössä, sizer siirtää sisällön. 
     Asemoidaan sisältö tällöin kattamaan koko ala. */
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>